
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import avt from "../../assets/images/Default_user_image.png";
import { Link, NavLink } from "react-router-dom";
import axios from "../../API/axios";
// import Notification from '../NotificationPage/Notification';
// import { Notification } from '../NotificationPage/Notification';
import Notification from '../../khojpages/NoticationPage/Notification';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
// import SampleCV from "../../pages/SampleCV";
// import Blog_v1 from "../../pages/Blog_v1";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import { SearchOutlined } from "@mui/icons-material";
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import LogoutSharpIcon from '@mui/icons-material/LogoutSharp';
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import WorkHistorySharpIcon from '@mui/icons-material/WorkHistorySharp';
import SettingsSharpIcon from '@mui/icons-material/SettingsSharp';

import NotificationsSharpIcon from '@mui/icons-material/NotificationsSharp';
import GobalSearch from "../../khojpages/GlobalSearch/GobalSearch";


InstituteHeader.propTypes = {};

function InstituteHeader({ clname = "", handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    // ..................................................................................
    // ..................................................................................
    // Get the sessionId from localStorage
    const sessionId = localStorage.getItem("sessionId");
    const profileImage = localStorage.getItem("profilPic");
    // const profileImage = localStorage.getItem("profilePic");

    // Initialize state variables for notifications and notification count
    const [notifi, setNotifi] = useState([]);
    const [notifiCount, setNotifiCount] = useState("");

    // Async function to get the top 5 notifications
    const NotificationList = async () => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,  // sessionId from localStorage
        };

        try {
            // Make the POST request to the server
            const resData = await axios.post(`V1/General/GetTop5Notifications`, data);

            // Log the response data to the console
            console.log("Response Data:", resData.data.responseData);

            // Set the notifications state with the response data
            setNotifi(resData.data.responseData);

            // Optionally, log the state update to check if notifications were set correctly
            console.log("Notifications after set:", notifi);
        } catch (error) {
            // Handle error if the server returns a 404 status
            if (error.response && error.response.status === 404) {
                console.log("Error 404: Not Found");
            } else {
                // Log any other error
                console.log(error);
            }
        }
    };


    // Example data for each tab
    const [activeTab, setActiveTab] = useState('notification'); // Active tab tracking
    const notifications = [
        { time: 'Last day', content: 'Your submit job Graphic Design is Success' },
        { time: '5 Days ago', content: 'A new application is submitted on your job Graphic Design by Maverick Nguyen' },
    ];

    const alertjobs = [
        { time: 'Last day', content: 'Your Graphic Design job has been posted successfully' },
        { time: '3 Days ago', content: 'Another applicant applied for Graphic Design' },
    ];

    const Interviews = [
        { time: 'Yesterday', content: 'Your interview for Graphic Design is scheduled for tomorrow' },
    ];

    const dismissNotification = (id, setState) => {
        setState((prev) => prev.filter((item) => item.id !== id));
    };

    // Function to render content based on the selected tab
    const renderContent = (items, setState) =>
        items.map((item, index) => (
            <div key={index} className=" ">
                <div className="mt-1">
                    <div className="sub-notification-content">
                        <div className="sub-notification-item icon-plus">
                            <div className="time Notification-Text">{item.time}</div>
                            <div className="content Notification-Text">
                                {item.content}
                                {/* <span className="name">Graphic Design</span> is&nbsp;
                          <span className="status">Success</span> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>


        ));

    const [userData, setUserData] = useState({
        entityName: "",
        email: "",
        userType: "",
        profilPic: ""
    });

    useEffect(() => {
        const entityName = localStorage.getItem("entityName");
        const email = localStorage.getItem("email");
        const userType = localStorage.getItem("userType");
        const profilPic = localStorage.getItem("profilPic");

        setUserData({ entityName, email, userType, profilPic });
    }, []);




    // ........................................................................
    // ........................................................................
    return (
        <>
            <header
                id="header"
                className={`header khojdesktopHeader pt-3 header-default loginkhojHeader`}
            >
                <div className="px-4 ct2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="sticky-area-wrap">
                                <div className="header-ct-left">
                                    {isDark ? (
                                        <div id="logo" className="logo">
                                            <Link to="/Home">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo2}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    ) : (
                                        <div id="logo" className="logo">
                                            <Link to="/Home">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                <div className="form-group-1 khojSearch d-flex align-items-center">
                                    {/* <SearchOutlined className="searchIcon" />
                                    <input
                                        type="text"
                                        className="input-filter-search"
                                        placeholder="Search"
                                    /> */}
                                    <GobalSearch />
                                </div>
                                <div className="header-ct-center">
                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav">
                                            <ul id="menu-primary-menu" className={`menu mb-2 ${clname}`}>
                                                {/* <li className="menu-item sub2">
                                                    <DashboardSharpIcon />
                                                    <NavLink to="/Dashboard">Dashboard</NavLink>
                                                </li> */}
                                                <li className="menu-item menu-item-has-children sub3">
                                                    <Link>
                                                    <AccountCircleSharpIcon className="pointer" />
                                                    </Link>
                                                    <Link >Candidates</Link>
                                                    <ul className="sub-menu st1">
                                                        <li className="nav-sub">
                                                            {/* <AccountCircleSharpIcon /> */}
                                                            <Link to="/InstituteCandidates">
                                                                Manage Candidate
                                                            </Link>
                                                        </li>
                                                        <li className="nav-sub">
                                                            {/* <AccountCircleSharpIcon /> */}
                                                            <NavLink to="/Addcandidate">
                                                                Add Candidate
                                                            </NavLink>
                                                        </li>
                                                        <li className="nav-sub">
                                                            {/* <AccountCircleSharpIcon /> */}
                                                            <NavLink to="/manageclass">
                                                                Manage Class
                                                            </NavLink>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li className="menu-item subjob">
                                                    <Link to="/SearchJobs">
                                                    <WorkSharpIcon  className="pointer"/>
                                                    </Link>
                                                    <NavLink to="/SearchJobs">Search Job</NavLink>
                                                </li>
                                                <li className="menu-item menu-item-has-children sub4">
                                                    <Link>
                                                    <WorkHistorySharpIcon />
                                                    </Link>
                                                    <Link to="#">Manage Job</Link>
                                                    <ul className="sub-menu st1">
                                                        <li className="nav-sub">
                                                            {/* <WorkSharpIcon /> */}
                                                            <Link to="/savedjobs">
                                                                Saved Jobs
                                                            </Link>
                                                        </li>
                                                        <li className="nav-sub">
                                                            {/* <WorkSharpIcon /> */}
                                                            <NavLink to="/Appliedjobs">
                                                                Applied Jobs
                                                            </NavLink>
                                                        </li>
                                                        {/* <li className="nav-sub">
                                                            <WorkSharpIcon />
                                                            <NavLink to="/BlockCompanies">
                                                                Block Companies
                                                            </NavLink>
                                                        </li> */}
                                                    </ul>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="header-ct-right">
                                    <Toggle
                                        isChecked={isDark}
                                        handleChange={() => setIsDark(!isDark)}
                                    />
                                    {/* <div className="header-customize-item bell ms-3">
                  <span className="icon-bell"></span>
                  <div className="sub-notification">
                    <div className="sub-notification-heading">
                      <div className="sub-notification-title">Notification</div>
                      <span>5 New</span>
                    </div>
                    <div className="sub-notification-content">
                      <div className="sub-notification-item ">
                        <div className="time">Last day</div>
                        <div className="content">
                          Your submit job
                          <span className="name">Graphic Design</span> is
                          <span className="status">Success</span>
                        </div>
                      </div>
                      <div className="sub-notification-item ">
                        <div className="time">5 Day ago</div>
                        <div className="content">
                          A new application is submitted on your job
                          <span className="name">Graphic Design</span> by
                          <span className="name">Maverick Nguyen</span>
                        </div>
                      </div>
                      <div className="sub-notification-item ">
                        <div className="time">5 Day ago</div>
                        <div className="content">
                          A new application is submitted on your job
                          <span className="name">Graphic Design</span> by
                          <span className="name">Maverick Nguyen</span>
                        </div>
                      </div>
                      <div className="sub-notification-item ">
                        <div className="time">Last day</div>
                        <div className="content">
                          Your submit job{" "}
                          <span className="name">Graphic Design</span> is
                          <span className="status">Success</span>
                        </div>
                      </div>
                      <div className="sub-notification-item ">
                        <div className="time">5 Day ago</div>
                        <div className="content">
                          A new application is submitted on your job
                          <span className="name">Graphic Design</span> by
                          <span className="name">Maverick Nguyen</span>
                        </div>
                      </div>
                    </div>
                    <div className="sub-notification-button">
                      <Link to="/notifications">Read All</Link>
                    </div>

                  </div>
                </div> */}
                                    <div className="header-customize-item bell ms-3">
                                        <span className="icon-bell"></span>
                                        <div className="sub-notification">
                                            {/* Tab Headers */}
                                            <div className="tabs">
                                                <div
                                                    className={`tab ${activeTab === 'notification' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('notification')}
                                                >
                                                    Notification
                                                </div>
                                                <div
                                                    className={`tab ${activeTab === 'alertjobs' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('alertjobs')}
                                                >
                                                    Job Notification
                                                </div>
                                                <div
                                                    className={`tab ${activeTab === 'Interviews' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('Interviews')}
                                                >
                                                    Interview
                                                </div>
                                            </div>

                                            {/* Tab Content */}
                                            <div className="sub-notification-content">
                                                {activeTab === 'notification' && renderContent(notifications)}
                                                {activeTab === 'alertjobs' && renderContent(alertjobs)}
                                                {activeTab === 'Interviews' && renderContent(Interviews)}

                                                <div className="sub-notification-button">
                                                    <Link to={`/${activeTab}`}>Read All</Link>
                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                    {/* <UncontrolledDropdown
                  tag=""
                  className="dropdown-notification nav-item me-25"
                >
                  <DropdownToggle
                    tag="a"
                    className="nav-link"
                    href="/"
                    onClick={(e) => e.preventDefault()}
                  >
                    <div className="header-customize-item account">
                      <img src={avt} alt="jobtex" className="userProfileHeader" />
                      <div className="d-flex align-items-center username">
                      </div>
                    </div>

                  </DropdownToggle>
                  <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0 userdataDropdown">

                    <>
                      <li className="dropdown-menu-header">
                        <DropdownItem className="d-flex align-items-center" tag="div" header>
                          <AccountCircleSharpIcon />
                          <span className="notification-title mb-0 me-auto ms-2">Profile</span>
                        </DropdownItem>
                      </li>

                      <li className="dropdown-menu-header">
                        <DropdownItem className="d-flex align-items-center" tag="div" header>
                          <DeleteForeverSharpIcon />
                          <span className="notification-title mb-0 me-auto ms-2">Change Password</span>
                        </DropdownItem>
                      </li>
                      <li className="dropdown-menu-header">
                        <DropdownItem className="d-flex align-items-center" tag="div" header>
                          <DeleteForeverSharpIcon />
                          <span className="notification-title mb-0 me-auto ms-2">Delete Profile</span>
                        </DropdownItem>
                      </li>
                      <li className="dropdown-menu-header">
                        <DropdownItem className="d-flex align-items-center" tag="div" header>
                          <LogoutSharpIcon />
                          <span className="notification-title mb-0 me-auto ms-2">Logout</span>
                        </DropdownItem>
                      </li>


                    </>
                  </DropdownMenu>
                </UncontrolledDropdown> */}


                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav">
                                            <ul id="menu-primary-menu" className={`menu profileMenu mb-2 p-0 ${clname}`}>


                                                <li className="menu-item menu-item-has-children profile-img m-0">
                                                    <Link to="#">
                                                        <img src={userData.profilPic}
                                                            width={40} alt="jobtex"
                                                            className="userProfileHeader " />
                                                    </Link>

                                                    <div className="header-customize-item bell pro  ">
                                                        <div className="sub-notification profile">
                                                            <div className="tabs row">
                                                                <li>
                                                                    <div className=" d-flex HeaderFLName">
                                                                        <h6> {`${userData.entityName} `}</h6>
                                                                    </div >
                                                                    <div className="HeaderEmail" >
                                                                        <h6> {userData.email}</h6>
                                                                    </div>
                                                                    <div className="HeaderUserType">
                                                                        <h6> {userData.userType}</h6>
                                                                    </div>
                                                                </li>
                                                                <li className="nav-sub">
                                                                    <AccountCircleSharpIcon />
                                                                    <Link to="/Profile">
                                                                        Profile
                                                                    </Link>

                                                                </li>
                                                                {/* <li className="nav-sub">
                                                                <DeleteForeverSharpIcon />
                                                                <NavLink to="/changepassword">
                                                                Change Password
                                                                </NavLink>
                                                            </li> */}
                                                                <li className="nav-sub">
                                                                    <SettingsSharpIcon />
                                                                    <NavLink to="/Settings">
                                                                        Settings
                                                                    </NavLink>
                                                                </li>
                                                                <li className="nav-sub" >
                                                                    <LogoutSharpIcon />
                                                                    <NavLink
                                                                        to="/login"
                                                                        onClick={() => {
                                                                            const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
                                                                            localStorage.clear(); // Clear all localStorage
                                                                            if (isDarkValue !== null) {
                                                                                localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
                                                                            }
                                                                        }}
                                                                    >
                                                                        Logout
                                                                    </NavLink>
                                                                </li>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>

                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="nav-filter" onClick={handleMobile}>
                                    <div className="nav-mobile">
                                        <span></span>
                                    </div>
                                </div>

                                {/* <div className="" style={{ margin: '5px' }}>
                <Link to="/forgetpassword">
                  <button>Forget</button>
                </Link>

              </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <header
                id="header"
                className={`header khojmobileHeader pt-3 header-default loginkhojHeader `}
            >
                <div className="px-4 ct2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="sticky-area-wrap">
                                <div className="header-ct-left">
                                    <div className="nav-wrap">
                                        <nav id="main-nav" className="main-nav profileNav">
                                            <ul id="menu-primary-menu" className={`menu profileMenu mb-2 ${clname} Nav-Header-Mobile`}>


                                                <li className="menu-item menu-item-has-children">
                                                    <Link to="#">
                                                        <img src={avt} width={40} alt="jobtex" className="userProfileHeader" />
                                                    </Link>
                                                    <ul className="sub-menu st1">
                                                        <li className="nav-sub">
                                                            <AccountCircleSharpIcon />
                                                            <Link to="/Profile">
                                                                Profile
                                                            </Link>

                                                        </li>
                                                        <li className="nav-sub">
                                                            <DeleteForeverSharpIcon />
                                                            <NavLink to="/changepassword">
                                                                Change Password
                                                            </NavLink>
                                                        </li>
                                                        <li className="nav-sub">
                                                            <DeleteForeverSharpIcon />
                                                            <NavLink to="/deleteprofile">
                                                                Delete Profile
                                                            </NavLink>
                                                        </li>
                                                        <li className="nav-sub" >
                                                            <LogoutSharpIcon />
                                                            <NavLink
                                                                to="/login"
                                                                onClick={() => {
                                                                    const isDarkValue = localStorage.getItem('isDark'); // Store the value of isDark
                                                                    localStorage.clear(); // Clear all localStorage
                                                                    if (isDarkValue !== null) {
                                                                        localStorage.setItem('isDark', isDarkValue); // Restore the isDark key if it exists
                                                                    }
                                                                }}
                                                            >
                                                                Logout
                                                            </NavLink>
                                                        </li>

                                                    </ul>
                                                </li>

                                            </ul>
                                        </nav>
                                    </div>
                                    {isDark ? (
                                        <div id="logo" className="logo">
                                            <Link to="/">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo2}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    ) : (
                                        <div id="logo" className="logo">
                                            <Link to="/">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={logo}
                                                    alt="Image"
                                                />
                                            </Link>
                                        </div>
                                    )}
                                </div>

                                <div className="header-ct-right">
                                    <div className="header-customize-item bell mt-0 ms-3">
                                        <span className="icon-bell"></span>
                                        <div className="sub-notification">
                                            {/* Tab Headers */}
                                            <div className="tabs">
                                                <div
                                                    className={`tab ${activeTab === 'notification' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('notification')}
                                                >
                                                    Notification
                                                </div>
                                                <div
                                                    className={`tab ${activeTab === 'alertjobs' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('alertjobs')}
                                                >
                                                    Job Notification
                                                </div>
                                                <div
                                                    className={`tab ${activeTab === 'Interviews' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('Interviews')}
                                                >
                                                    Interview
                                                </div>
                                            </div>

                                            {/* Tab Content */}
                                            <div className="sub-notification-content">
                                                {activeTab === 'notification' && renderContent(notifications)}
                                                {activeTab === 'alertjobs' && renderContent(alertjobs)}
                                                {activeTab === 'Interviews' && renderContent(Interviews)}

                                                <div className="sub-notification-button">
                                                    <Link to={`/${activeTab}`}>Read All</Link>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="ms-auto me-2 mobileToggle">
                                        <Toggle
                                            isChecked={isDark}
                                            handleChange={() => setIsDark(!isDark)}
                                        />
                                    </div>
                                    <div className="nav-filter" onClick={handleMobile}>
                                        <div className="nav-mobile">
                                            <span></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default InstituteHeader;







